import { SpreadSheetList } from '@nuvo-importer/common/sdk';

export const isDynamicImport = (spreadSheetList: SpreadSheetList) => {
  return spreadSheetList.getSpreadSheets()[0].getType() === 'dynamic-import';
};
